import React from "react";
import AuthLayout from "../../Components/Layouts/AuthLayout";

const Interview = () => {
  return <AuthLayout>Interview</AuthLayout>;
};

export default Interview;
